export default __webpack_public_path__ + "static/media/icone-play-rounded.587ca2ec.svg";